document.addEventListener('DOMContentLoaded', () => {
  Array.from(document.querySelectorAll('div.dropdown-menu a.dropdown-option')).forEach((el) => {
    el.addEventListener('click', (e) => {
      const target = e.target.dataset.for;
      if (target === undefined) return;

      document.getElementById(target).value = e.target.dataset.value;
      document.getElementById(`btn-${target}`).innerHTML = `${e.target.innerText} <i class="uil uil-angle-down"></i>`;
    });
  });
});
